import { LandlordSelector } from "js/pages/Tenants/components/LandlordSelector";
import { SelectedLandlord } from "js/pages/Tenants/types";

interface LandlordSelectionStepProps {
  selectedLandlord: SelectedLandlord;
  onSelectLandlord: (landlord: SelectedLandlord) => void;
}

export const LandlordSelectionStep = ({
  selectedLandlord,
  onSelectLandlord,
}: LandlordSelectionStepProps) => {
  return (
    <LandlordSelector
      selectedLandlord={selectedLandlord}
      onSelectLandlord={onSelectLandlord}
    />
  );
};
